import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty } from 'lodash';
import Dashboard from '../../components/myaccount/Dashboard/Dashboard';
import { HomeSelector } from '../reducers/HomeReducer';
import { MyAccountSelector } from '../reducers/MyAccountReducer';
import MyAccountAction from '../actions/MyAccountAction';
import HomeAction from '../actions/HomeAction';
import SignupPaymentAction from '../actions/SignupPaymentAction';
import { ConfigSelector } from '../reducers/ConfigReducer';
import ConfigAction from '../actions/ConfigAction';

const mapStateToProps = state => ({
  customerInfo: MyAccountSelector.getCustomerInfo(state),
  updatePaymentSuccess: state.myAccount.updatePaymentSuccess,
  payNowSuccess: state.myAccount.payNowSuccess,
  plans: state.plans,
  hasError: !isEmpty(HomeSelector.getError(state)),
  error: HomeSelector.getError(state),
  isCovid19Mode: ConfigSelector.isCovid19Mode(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    checkSession: MyAccountAction.checkSession,
    clearAllDashboardNotifications: MyAccountAction.clearAllDashboardNotifications,
    resetPlanData: MyAccountAction.resetPlanData,
    resetFormData: SignupPaymentAction.resetCheckoutForm,
    resetAddressSearch: HomeAction.resetAddressSearchAll,
    storeStaticConfig: ConfigAction.storeStaticConfig
  }, dispatch);


const DashboardContainer = connect(mapStateToProps, mapDispatchToProps)(Dashboard);

export default DashboardContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/DashboardContainer.js
 **/